module.exports = __webpack_public_path__ + "img/page-13.58887815.jpg";